import React, { Component } from 'react';

class LogOut extends Component {

    componentWillMount(){
        document.location.href = '/logout';
    }

    render() {
        return (
            <h1>Signing Out....</h1>
        )
    }
}

export default LogOut;
